import React from 'react'
import PropTypes from 'prop-types'
import { lightFormat } from 'date-fns'
import { timeFormat } from 'constants/dateFormats'
import { Text } from 'shared/components'

export const TimeCell = ({ value }) => {
  return !value ? (
    <Text size={11}>–</Text>
  ) : (
    <Text size={11}>{lightFormat(new Date(value), timeFormat)}</Text>
  )
}

TimeCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
